<template>
<div class="first_step">
    <ul class="content_ul" v-if="showFirstContent">
        <li class="content_li" v-for="(item,index) in branchList" :key="index" @click="toOtherNext(item)">
            <div class="img_area">
                <div class="img_wrap img_wrap_1" v-if="item.coverMaterialUrl">
                    <div class="mask"></div>
                    <img :src="item.coverMaterialUrl | addHost" alt="hi">
                    <!-- <img src="../../assets/images/parent-course/girl.png" alt="girl"> -->
                </div>
                <div class="img_wrap img_wrap_2" v-if="!item.coverMaterialUrl">
                    <div class="mask"></div>
                    <img src="../../assets/images/parent-course/block.png" alt="hi">
                    <!-- <img src="../../assets/images/parent-course/girl.png" alt="girl"> -->
                </div>
                <p class="desc">{{item.name}}</p>
            </div>
        </li>
    </ul>
    <!-- <div class="loading_area">
        <loading v-if="loadingStatus2"></loading>
    </div> -->
</div>
</template>

<script>
export default {
  name: 'first-step-other',
  components: {},
  props: {
    showFirstContent: {
        type: Boolean,
        default:true
    },
    branchList: {
        type: Array,
        default:() => []
    }
  },
  data() {
    return {
        // loadingStatus2:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 二级维度下，点击跳转到三级维度
    toOtherNext(item) { 
        this.$storage.setStore('firstOtherPlateInfo',item)
        this.$router.push('/thirdPlate')
    }, 
  },
  filters: {
    addHost: function(val) {
        let host = location.host
        // return 'http://' + host + '/' + val
        // return 'http://172.16.12.104:8999/' + val
        return val
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.first_step {
    .content_ul {
        .content_li {
            width: 345px;
            min-height: 210px;
            margin-bottom: 20px;
            background-color: #fff;
            border-radius: 16px;
            box-shadow: 0px 2px 5px 1px rgba(217, 217, 217,.2);
            &:first-child {
                margin-top: 20px;
            }
            .img_area {
                position: relative;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .img_wrap {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 15px;       
                    width: 315px;
                    height: 180px;
                    border-radius: 8px;
                    background-color: #f8f7fa;
                    position: relative;
                    .mask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: rgba(0,0,0,.1);
                        border-radius: 8px;
                    }
                    &.img_wrap_1 {
                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 8px;
                        }
                    }
                    &.img_wrap_2 {
                        img {
                            width: 44px;
                            height: 44px;
                        }
                    }
                }
                .desc {
                    position: absolute;
                    bottom: 16px;
                    left: 32px;
                    height: 22px;
                    font-size: 16px;
                    color: #fff !important;
                    line-height: 22px;
                }
            }
        }
    }
    // .loading_area {
    //     position: absolute;
    //     top:50%;
    //     left: 50%;
    //     transform: translate(-50%,-50%);
    // }
}
</style>
